import { Row } from '@design-system/components/grid/grid';
import { ExternalLink } from '@design-system/components/link/externalLink';
import { Typography } from '@design-system/components/typography/typography';
import { wrapper } from './PriceInfo.css';
import { SubscriptionBundlesVM } from '../../viewModel/subscriptionBundles.viewModel';

type PriceInfoProps = {
  dispatch: SubscriptionBundlesVM['dispatch'];
};

export const PriceInfo = ({ dispatch }: PriceInfoProps) => {
  return (
    <div className={wrapper}>
      <Typography variant="body" size="medium">
        How to price your subscription?
      </Typography>
      <Row alignCenter>
        <Typography variant="body" size="medium" fontWeight="normal">
          Watch a video or read up on the best pricing practices for your
          subscription
        </Typography>
        <ExternalLink
          label="here"
          textColor="P-80"
          textVariant="body"
          textSize="medium"
          onClick={() => dispatch('helpMaterialsEvent', 'pricingArticle')}
          href="https://help.playbookapp.io/en/articles/13621806-how-to-turn-on-an-exclusive-subscription"
        />
      </Row>
    </div>
  );
};
